import QuickForm from "../../Forms/QuickForm/QuickForm"
import * as yup from 'yup'

export const EditPropertyParkingLinkedServiceForm = (props: {
    initialData: any,
    onSubmit: (linkedServiceData: any) => void
    onCancel?: () => void
}) => {
    const {
        initialData = {},
        onSubmit,
        onCancel,
    } = props

    let parsedInitialData: any = {}
    try {
        parsedInitialData = initialData?.linkedServiceId ? JSON.parse(initialData.linkedServiceId) : {}
        if (parsedInitialData.parkingGroups) {
            parsedInitialData.parkingGroups = parsedInitialData.parkingGroups.map((group: any) => {
                return { group: group }
            })
        }
    } catch (e) {
        parsedInitialData = {}
    }

    return (
        <QuickForm
            initialData={{
                parkingType: 'PARKING_TYPE',
                parkingCost: 35,
                parkingGroups: [{
                    tag: 'PARKING_LOCATION'
                }],
                ...parsedInitialData
            }}
            // onSubmit={onSubmit}
            onSubmit={(data: any) => {
                console.log('data', data)
                try {
                    const processedData = {
                        ...data,
                        parkingGroups: data.parkingGroups.map((group: any) => group.group)
                    }
                    delete processedData.tempGroup
                    onSubmit(processedData)
                } catch (e) {
                    console.log('error stringifying linked service data', e);
                }
            }}
            onCancel={onCancel}
            validationSchema={yup.object().shape({
                parkingType: yup.string().required('Parking Type is required'),
                parkingCost: yup.number().required('Parking Cost is required').min(0, 'Parking Cost cannot be negative'),
                parkingGroups: yup.array().of(yup.object().shape({
                    group: yup.string().required()
                }))
            })}
            fields={[
                {
                    fieldType: 'text',
                    fieldName: 'parkingType',
                    fieldLabel: 'Parking Type',
                    placeholder: 'Enter Parking Type',
                },
                {
                    fieldType: 'number',
                    fieldName: 'parkingCost',
                    fieldLabel: 'Parking Cost',
                    placeholder: 'Enter Parking Cost',
                },
                {
                    fieldName: 'parkingGroups',
                    fieldLabel: 'Parking Groups',
                    fieldType: 'quickTag',
                    placeholder: 'Groups',
                    extra: {
                        title: 'Parking Groups',
                        breakAfter: true,
                        options: {
                            // hideInput: true,
                            // hideBadges: true,
                        },
                        tempFieldName: 'tempGroup',
                        tagEntryName: 'group',
                        buttons: [
                            { tag: '1212-Lincoln-Garage', text: '1212-Lincoln-Garage' },
                            { tag: '929-Alton-Rd-Garage', text: '929-Alton-Rd-Garage' },
                        ]
                    }
                },
            ]}
        />
    )
}

export const EditPropertyRemoteLockLinkedServiceForm = (props: {
    initialData: any,
    onSubmit: (linkedServiceData: any) => void
    onCancel?: () => void
}) => {
    const {
        initialData = {},
        onSubmit,
        onCancel,
    } = props

    let parsedInitialData = {}
    try {
        parsedInitialData = initialData?.linkedServiceId ? JSON.parse(initialData.linkedServiceId) : {}
    } catch (e) {
        parsedInitialData = {}
    }
    return (
        <QuickForm
            initialData={{
                deviceId: '',
                deviceName: '',
                deviceType: '',
                guestControl: false,
                ...parsedInitialData
            }}
            onSubmit={onSubmit}
            onCancel={onCancel}
            validationSchema={yup.object().shape({
                deviceId: yup.string().required('Device ID is required').matches(/^[A-Za-z0-9]{8}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{12}$/i, 'Device ID must be in the format XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX'),
                deviceName: yup.string().required('Device Name is required'),
                deviceType: yup.string().required('Device Type is required'),
                guestControl: yup.boolean(),
            })}
            fields={[
                {
                    fieldType: 'custom',
                    fieldName: 'info',
                    fieldLabel: '',
                    extra: {
                        component: () => {
                            return (
                                <div className="small">
                                    <p>
                                        You can grab the Device ID and Device Type from the URL in your browser's address bar. <br />
                                        The URL will look something like this: <br />
                                        <span className="text-break">
                                            https://connect.remotelock.com/devices/DEVICE_TYPE/DEVICE_ID/access/all
                                        </span>
                                    </p>
                                </div>
                            )
                        },
                    }
                },
                {
                    fieldType: 'text',
                    fieldName: 'deviceName',
                    fieldLabel: 'Device Name',
                    placeholder: 'Enter Device Name',
                },
                {
                    fieldType: 'text',
                    fieldName: 'deviceId',
                    fieldLabel: 'Device ID',
                    placeholder: 'Enter Device ID',
                    layout: {
                        xs: 12,
                        md: 6,
                    }
                },
                {
                    fieldType: 'select',
                    fieldName: 'deviceType',
                    fieldLabel: 'Device Type',
                    placeholder: 'Enter Device Type',
                    options: [
                        {
                            text: 'locks',
                            value: 'locks',
                        },
                        {
                            text: 'connector-locks',
                            value: 'connector-locks',
                        },
                        {
                            text: 'schlage-home-locks',
                            value: 'schlage-home-locks',
                        }
                    ],
                    layout: {
                        xs: 12,
                        md: 6,
                    }
                },
                {
                    fieldType: 'checkbox',
                    fieldName: 'guestControl',
                    fieldLabel: 'Guest Control',
                },
            ]}
        />
    )
}

export const EditFontainePortalLinkedServiceForm = (props: {
    initialData: any,
    onSubmit: (linkedServiceData: any) => void
    onCancel?: () => void
}) => {
    const {
        initialData = {},
        onSubmit,
        onCancel,
    } = props

    let parsedInitialData = {}
    try {
        parsedInitialData = initialData?.linkedServiceId ? JSON.parse(initialData.linkedServiceId) : {}
    } catch (e) {
        parsedInitialData = {}
    }

    return (
        <QuickForm
            initialData={{
                username: '',
                password: '',
                email: '',
                phone: '',
                ...parsedInitialData
            }}
            onSubmit={onSubmit}
            onCancel={onCancel}
            validationSchema={yup.object().shape({
                username: yup.string().required('Username is required'),
                password: yup.string().required('Password is required'),
                email: yup.string().email('Invalid email format').required('Email is required'),
                phone: yup.string().required('Phone number is required'),
            })}
            fields={[
                {
                    fieldType: 'text',
                    fieldName: 'username',
                    fieldLabel: 'Fontaine Portal Username',
                    placeholder: 'Enter Fontaine Portal Username',
                },
                {
                    fieldType: 'text',
                    fieldName: 'password',
                    fieldLabel: 'Fontaine Portal Password',
                    placeholder: 'Enter Fontaine Portal Password',
                },
                {
                    fieldType: 'text',
                    fieldName: 'email',
                    fieldLabel: 'Email Address',
                    placeholder: 'Enter Email Address',
                },
                {
                    fieldType: 'text',
                    fieldName: 'phone',
                    fieldLabel: 'Phone Number',
                    placeholder: 'Enter Phone Number',
                },
            ]}
        />
    )
}

export const EditEarlyCheckInLateCheckoutLinkedServiceForm = (props: {
    initialData: any,
    onSubmit: (linkedServiceData: any) => void
    onCancel?: () => void
}) => {
    const {
        initialData = {},
        onSubmit,
        onCancel,
    } = props
    let parsedInitialData = {}
    try {
        parsedInitialData = initialData?.linkedServiceId ? JSON.parse(initialData.linkedServiceId) : {}
    } catch (e) {
        parsedInitialData = {}
    }

    let type: 'earlyCheckIn' | 'lateCheckOut' = 'lateCheckOut'
    if (initialData?.linkedService === 'earlyCheckIn') {
        type = 'earlyCheckIn'
    }

    return (
        <QuickForm
            initialData={{
                enabled: true,
                options: [],
                ...parsedInitialData
            }}
            onSubmit={onSubmit}
            onCancel={onCancel}
            validationSchema={earlyCheckinLateCheckoutValidation}
            fields={[
                {
                    fieldType: 'custom',
                    fieldName: 'info',
                    fieldLabel: '',
                    extra: {
                        component: () => {
                            return (
                                <div className="small">
                                    <p>
                                        The option title is what will appear to guests when selecting this service. <br />
                                        The number of hours indicates how many hours it will extend their check-in or check-out time. Make sure this is a positive number. <br />
                                        The option price is the additional cost for this service. This can be set to 0 for free options.
                                    </p>
                                </div>
                            )
                        },
                    }
                },
                {
                    fieldType: 'array',
                    fieldName: 'options',
                    fieldLabel: type === 'earlyCheckIn' ? 'Early Check-In Options' : 'Late Check-Out Options',
                    extra: {
                        fields: [
                            {
                                fieldType: 'text',
                                fieldName: 'title',
                                fieldLabel: 'Option Title',
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldType: 'number',
                                fieldName: 'hours',
                                fieldLabel: 'Hours',
                                layout: {
                                    xs: 6,
                                    md: 3,
                                }
                            },
                            {
                                fieldType: 'number',
                                fieldName: 'price',
                                fieldLabel: 'Price',
                                layout: {
                                    xs: 6,
                                    md: 3,
                                }
                            }
                        ],
                        blankEntryFn: () => {
                            return {
                                title: '',
                                hours: 1,
                                price: 0,
                            }
                        }
                    }
                },
                {
                    fieldType: 'checkbox',
                    fieldName: 'enabled',
                    fieldLabel: type === 'earlyCheckIn' ? 'Enable Early Check-In Service' : 'Enable Late Check-Out Service',
                    placeholder: '',
                },
            ]}
        />
    )
}

const earlyCheckinLateCheckoutValidation = yup.object().shape({
    enabled: yup.bool().required(),
    options: yup.array().of(yup.object().shape({
        title: yup.string().required(),
        // must be greater than 0
        hours: yup.number().required().min(1, 'Hours must be at least 1'),
        price: yup.number().required(),
    }))
})

export const EditGateCodeLinkedServiceForm = (props: {
    initialData: any,
    onSubmit: (linkedServiceData: any) => void
    onCancel?: () => void
}) => {
    const {
        initialData = {},
        onSubmit,
        onCancel,
    } = props

    let parsedInitialData = {}
    try {
        parsedInitialData = initialData?.linkedServiceId ? JSON.parse(initialData.linkedServiceId) : {}
    } catch (e) {
        parsedInitialData = {}
    }

    return (
        <QuickForm
            initialData={{
                codes: [
                    {
                        for: 'CODE_FOR',
                        code: 'CODE_NUMBER'
                    }
                ],
                ...parsedInitialData
            }}
            onSubmit={onSubmit}
            onCancel={onCancel}
            validationSchema={yup.object().shape({
                codes: yup.array().of(yup.object().shape({
                    for: yup.string().required('For field is required'),
                    code: yup.string().required('Code is required'),
                }))
            })}
            fields={[
                {
                    fieldType: 'array',
                    fieldName: 'codes',
                    fieldLabel: 'Gate Codes',
                    extra: {
                        fields: [
                            {
                                fieldType: 'text',
                                fieldName: 'for',
                                fieldLabel: 'For',
                                placeholder: 'e.g., building, gate, parking',
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldType: 'text',
                                fieldName: 'code',
                                fieldLabel: 'Code',
                                placeholder: 'Enter gate code',
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            }
                        ],
                        blankEntryFn: () => {
                            return {
                                for: '',
                                code: '',
                            }
                        }
                    }
                },
            ]}
        />
    )
}

export const propertyLinkedServiceForms: Record<string, any> = {
    earlyCheckIn: EditEarlyCheckInLateCheckoutLinkedServiceForm,
    lateCheckOut: EditEarlyCheckInLateCheckoutLinkedServiceForm,
    fontainePortal: EditFontainePortalLinkedServiceForm,
    remoteLock: EditPropertyRemoteLockLinkedServiceForm,
    parking: EditPropertyParkingLinkedServiceForm,
    gateCode: EditGateCodeLinkedServiceForm,
}
